export const messages = {
  // Navigation
  "nav.today": "Vandaag",
  "nav.areas": "Thema's",
  "nav.goals": "Doelen",
  "nav.routines": "Routines",
  "nav.calendar": "Kalender",
  "nav.library": "Bibliotheek",
  "nav.home": "Home",
  "nav.pricing": "Prijzen",
  "nav.settings": "Instellingen",
  health: "Gezondheid",

  // Buttons
  "button.login": "Inloggen",
  "button.register": "Registreren",
  "button.start_now": "Direct Starten",
  "button.continue": "Doorgaan",
  "button.back": "Terug",

  appDescription:
    "ProgressMade biedt de tools om doelen te stellen, routines op te bouwen en je voortgang te visualiseren in alle aspecten van gezond leven – van fitness en voeding tot mindfulness en slaap.",

  // Onboarding
  "onboarding.welcome_title": "Welkom bij ProgressMade!",
  "onboarding.already_have_account": "Heb je al een account?",
  "onboarding.select_health_areas": "Selecteer {healthAreas}",
  "onboarding.select_health_areas_description":
    "Welke gezondheidsthema's wil je verbeteren? Kies maximaal {maxAreas} gezondheidsthema's waar je je op wilt richten.",
  "onboarding.select_health_areas_counter_empty": "Tik op de gebieden die belangrijk voor je zijn",
  "onboarding.select_health_areas_counter": "{selected} van {max} gezondheidsthema's geselecteerd",
  "onboarding.calendar_setup": "Stel je {calendar} in",
  "onboarding.calendar_setup_description": "Kies hoe je kalender eruit moet zien en moet werken.",
  "onboarding.notifications": "Notificaties",
  "onboarding.notifications_description":
    "Zet notificaties aan die je opweg helpen naar je beste zelf. Je kunt het!",
  "onboarding.user_segmentation_title": "Wat betekent {health} voor jou?",
  "onboarding.user_segmentation_subtitle": "Selecteer alles wat van toepassing is",
  "onboarding.referral_source_title": "Hoe heb je {appName} ontdekt?",
  "onboarding.profile_setup": "Voltooi je profiel",
  "onboarding.create_routine": "Creëer je eerste routine",
  "onboarding.create_routine_description":
    "Begin met het opbouwen van gezonde gewoonten die blijven plakken. Ontwerp een routine die bij je levensstijl past en je helpt je welzijnsdoelen te bereiken.",
  "onboarding.feature_overview.habit_streaks.title": "Gewoonte Streaks",
  "onboarding.feature_overview.habit_streaks.description":
    "Blijf gemotiveerd door je {consistencyStreaks} bij te houden en {lastingHabits} op te bouwen. Zie je vooruitgang terwijl je dagelijkse routines volhoudt en nieuwe mijlpalen bereikt.",
  "onboarding.feature_overview.health_calendar.title": "Gezondheidskalender",
  "onboarding.feature_overview.health_calendar.description":
    "Je routines en doelen worden automatisch ingepland in je kalender. In de kalender zie je overzichtelijk welke gezondheidsactiviteiten je hebt gepland.",
  "onboarding.feature_overview.smart_notifications.title": "Slimme Notificaties",
  "onboarding.feature_overview.smart_notifications.description":
    "Ontvang tijdige herinneringen voor je gezondheidsroutines en motiverende berichten om je op koers te houden met je doelen.",
  "onboarding.referral_options.social_media": "Sociale Media",
  "onboarding.referral_options.friend_family": "Vriend of Familie",
  "onboarding.referral_options.search_engine": "Zoekmachine",
  "onboarding.referral_options.blog_article": "Blog of Artikel",
  "onboarding.referral_options.health_professional": "Zorgverlener",
  "onboarding.referral_options.app_store": "App Store",
  "onboarding.referral_options.advertisement": "Advertentie",
  "onboarding.referral_options.somewhere_else": "Ergens anders",
  "onboarding.referral_other_placeholder": "Vertel ons hoe je ProgressMade hebt ontdekt...",
  "onboarding.user_segments.energy_vitality": "Elke dag energie en vitaliteit hebben",
  "onboarding.user_segments.balanced_lifestyle": "Een evenwichtige levensstijl behouden",
  "onboarding.user_segments.mental_emotional": "Mentale en emotionele welzijn",
  "onboarding.user_segments.physical_fitness": "Fysiek sterk en fit zijn",
  "onboarding.user_segments.sleep_rest": "Goede slaap en rust",
  "onboarding.user_segments.nutrition": "Voedzaam eten",
  "onboarding.user_segments.stress_management": "Stress beheren",
  "onboarding.button.select_areas": "Selecteer Thema's",
  "onboarding.button.select_option": "Selecteer een optie",
  "onboarding.button.select_at_least_one": "Selecteer minimaal één optie",

  // Cookie Consent
  "cookie.title": "Maar eerst, cookies 🍪",
  "cookie.description":
    "We gebruiken essentiële cookies om onze service goed te laten functioneren en verzamelen anonieme gebruiksgegevens om je ervaring te verbeteren.",
  "cookie.accept": "Accepteren & Doorgaan",
  "cookie.error": "Kan cookie-toestemming niet opslaan",

  // Homepage
  "home.hero.feature_badges.boost_energy": "Verhoog Dagelijkse Energie",
  "home.hero.feature_badges.transform_sleep": "Verbeter Je Slaap",
  "home.hero.feature_badges.feel_better": "Voel Je Elke Dag Beter",
  "home.hero.heading": "Plan Je Gezondheid",
  "home.hero.subheading":
    "ProgressMade is de {googleCalendar} voor je gezondheid. Word wakker met meer energie. Voel je zelfverzekerd over je voedingskeuzes. Haal het maximale uit je workouts.",
  "home.hero.google_calendar": "Google Calendar",
  "home.hero.start_now": "Direct Starten",
  "home.hero.download_app_store": "Download in App Store",
  "home.hero.download_google_play": "Download op Google Play",
  "home.hero.social_proof.see_stories": "Bekijk Succesverhalen",
  "home.hero.social_proof.app_store_rating": "App Store beoordeling",
  "home.hero.start_button_title": "Begin met ProgressMade.ai - Start je gezondheidsreis",
  "home.hero.download_button_title": "Download ProgressMade.ai uit de App Store",
  "home.hero.image_alt":
    "ProgressMade.ai mobiele app interface met gezondheidsmonitoring en wellness functies",

  // Goals
  "goals.1": "Maak je lichaam wakker met een ochtendstretch van 10 minuten.",
  "goals.2": "Energie voor je middag met een eiwitrijke lunch vol groenten.",
  "goals.3":
    "Bereid je voor op diepe slaap door de nachtmodus een uur voor het slapengaan in te schakelen.",
  "goals.4": "Start je metabolisme op door 's ochtends direct te hydrateren en te ontbijten.",
  "goals.5": "Vind je rust met een ademhalingsoefening van 5 minuten bij stress.",
  "goals.6": "Reset je focus met een beweegpauze van 10 minuten.",
  "goals.7": "Boost je vitaliteit met een portie vers fruit.",
  "goals.8": "Kies voor pure energie door een suikerhoudend drankje te vervangen door water.",
  "goals.9": "Blijf moeiteloos gehydrateerd door een waterfles bij de hand te houden.",
  "goals.10":
    "Verbeter je spijsvertering en ontspan met een rustige wandeling van 15 minuten na het eten.",
  "goals.11": "Neem je pauze terug door bewust te eten, weg van je scherm.",
  "goals.12": "Laat kantoorspanning los met een snelle nek- en schouderstretch.",
  "goals.13": "Voed jezelf van binnenuit door een handvol bladgroenten toe te voegen aan je diner.",
  "goals.14": "Plan voor succes door een gezonde snack voor te bereiden voor morgen.",
  "goals.15": "Vind fitness in je dagelijkse routine door de trap te nemen.",
  "goals.16": "Doorbreek een zittende dag door elk uur even op te staan en te bewegen.",

  // Features
  "features.title": "Je Gezondheid in orde",
  "features.description":
    "ProgressMade geeft je gezondheid dezelfde structuur en helderheid als je agenda. Het zet je goede voornemens om in een betrouwbaar plan, waardoor je dag na dag krachtig momentum opbouwt. Behaal blijvende resultaten door van consistentie je nieuwe standaard te maken.",
  "features.calendar.title": "Plan je gezonde activiteiten",
  "features.calendar.description":
    "Onze {healthCalendar} helpt je workouts, voeding, mentale en andere {healthyActivities} te plannen die je helpen {lifelongHealthyHabits} te creëren.",
  "features.calendar.health_calendar": "gezondheidskalender",
  "features.calendar.healthy_activities": "gezonde activiteiten",
  "features.calendar.lifelong_healthy_habits": "levenslange gezonde gewoonten",
  "features.calendar.schedule_routines": "Plan routines",
  "features.calendar.identify_patterns": "Identificeer optimale patronen",
  "features.calendar.visualize_progress": "Visualiseer vooruitgang",
  "features.goals.title": "Gezondheidsdoelen die belangrijk voor je zijn",
  "features.goals.description":
    "Stel betekenisvolle {healthGoals} in die zijn afgestemd op jouw behoeften. Ervaar tastbare verbeteringen in fitness en energie terwijl je je vertrouwen vergroot door {dailyProgress}.",
  "features.goals.health_goals": "gezondheidsdoelen",
  "features.goals.daily_progress": "dagelijkse vooruitgang",
  "features.notifications.title": "Notificaties die je in beweging houden",
  "features.notifications.description":
    "{consistency} is de sleutel tot succes in gezondheid en levensduur. Daarom hebben we {smartNotifications} gebouwd die zich aanpassen aan je schema en je op koers houden.",
  "features.notifications.consistency": "Consistentie",
  "features.notifications.smart_notifications": "slimme notificaties",
  "features.notifications.build_habits": "Bouw consistente gewoonten op",
  "features.notifications.personalized_nudges": "Gepersonaliseerde aanmoedigingen",
  "features.notifications.milestone_celebrations": "Mijlpaal vieringen",
  "features.ai.title": "Organiseer je gezondheid met AI",
  "features.ai.description":
    "ProgressMade heeft een AI-coach ontworpen die je unieke patronen leert en {nudgesYou}, en begeleiding biedt wanneer je het het meest nodig hebt, ongeacht je fitnessniveau.",
  "features.ai.nudges_you": "je aanspoort tot actie",
  "features.ai.creates_routines": "Creëert gepersonaliseerde routines",
  "features.ai.sets_milestones": "Stelt haalbare mijlpalen",
  "features.ai.breaks_down_goals": "Breekt gezondheidsdoelen af in eenvoudige dagelijkse acties",
  "features.streaks.title": "Gewoonte Streaks",
  "features.streaks.description":
    "Blijf gemotiveerd door je {consistencyStreaks} bij te houden en {lastingHabits} op te bouwen. Zie je vooruitgang terwijl je dagelijkse routines volhoudt en nieuwe mijlpalen bereikt.",
  "features.streaks.consistency_streaks": "streaks",
  "features.streaks.lasting_habits": "blijvende gewoonten",
  "features.streaks.track_consistency": "Volg dagelijkse consistentie",
  "features.streaks.celebrate_milestones": "Vier mijlpalen",
  "features.streaks.visualize_progress": "Visualiseer vooruitgang",

  // Social Proof
  "socialProof.title": "Vertrouwd door gezondheidsbewuste gebruikers",
  "socialProof.description":
    "Van betere slaapkwaliteit tot meer energie, onze community behaalt elke dag echte resultaten.",
  "socialProof.lovedByCommunity": "Geliefd door onze community",
  "socialProof.joinGrowingCommunity": "Sluit je aan bij onze groeiende community",
  "socialProof.verifiedUser": "Geverifieerde Gebruiker",
  "socialProof.testimonials.angela":
    "Gemotiveerd om vandaag een wandeling te maken dankzij ProgressMade. Ik wil vanavond mijn voltooide routines invoeren en de confetti-beloning ontvangen! De psychologische stok achter de deur werkt voor mij.",
  "socialProof.testimonials.esmee":
    "Ik gebruik ProgressMade nu al een paar weken en het is een game-changer voor me geweest. Ik ben erin geslaagd om bij mijn doelen te blijven en ze consistent te behalen. De app is gemakkelijk te gebruiken.",
  "socialProof.testimonials.david":
    "ProgressMade is een openbaring. Het helpt mijn gewoonten te identificeren en stuurt herinneringen. De visuele feedback van de gezondheidskalender maakt het volhouden belonend.",

  // CTA Section
  "cta.title": "Zorgen over je gezondheid?",
  "cta.description":
    "Neem controle over je gezondheidsreis. Bouw gezonde gewoonten op, volg je vooruitgang en behaal blijvende resultaten met gepersonaliseerde gezondheidsroutines.",
  "cta.start_now": "Start nu",
  "cta.image_alt":
    "ProgressMade.ai app interface met gepersonaliseerde gezondheidsroutines en wellness tracking functies",

  // FAQ Section
  "faq.title": "Veelgestelde Vragen",
  "faq.description": "Krijg snel antwoord op je vragen over ProgressMade.AI.",
  "faq.have_another_question": "Heb je nog een andere vraag?",
  "faq.contact_description":
    "Neem contact met ons op via {whatsappCommunityUrl} of per e-mail op {email}",
  "faq.contact_button": "Contact",

  // FAQ Sections
  "faq.sections.discovery": "Ontdekking",
  "faq.sections.features": "Functies",
  "faq.sections.personalization": "Personalisatie",
  "faq.sections.benefits": "Voordelen",
  "faq.sections.ease": "Gebruiksgemak",
  "faq.sections.pain": "Pijnpunten",

  // FAQ Questions & Answers - Discovery
  "faq.d1.question": "Is er een AI-app die mij helpt een dagelijkse routine op te bouwen?",
  "faq.d1.answer":
    "Ja! ProgressMade.ai is ontworpen om je te helpen een dagelijkse routine op te bouwen en te onderhouden met behulp van geavanceerde AI. Het analyseert je doelen en levensstijl om gepersonaliseerde routines te creëren die gemakkelijk te volgen zijn en zich aanpassen naarmate je vooruitgang boekt, waardoor het de perfecte metgezel is voor iedereen die zijn gezondheidsgewoonten wil optimaliseren.",
  "faq.d2.question": "Wat zijn de beste apps voor het bijhouden van gezondheidsgewoonten?",
  "faq.d2.answer":
    "ProgressMade.ai onderscheidt zich als de beste app voor het bijhouden van gezondheidsthema's. Het combineert krachtige AI met een intuïtieve interface, waardoor je je routines kunt monitoren, gepersonaliseerde suggesties kunt ontvangen en echte vooruitgang in je welzijn kunt zien—allemaal op één plek.",
  "faq.d3.question": "Ik heb een app nodig die mij helpt bij mijn fitnessdoelen.",
  "faq.d3.answer":
    "ProgressMade.ai is gebouwd om je te helpen consistent te blijven met je fitnessdoelen. De app gebruikt AI om op maat gemaakte routines te creëren, herinneringen te sturen en motiverende feedback te geven, zodat je op koers blijft en blijvende resultaten behaalt.",
  "faq.d4.question": "Zijn er apps die AI gebruiken om mijn gezondheidsplan te personaliseren?",
  "faq.d4.answer":
    "Absoluut! ProgressMade.ai gebruikt geavanceerde AI om je gezondheidsplan te personaliseren op basis van je unieke behoeften, voorkeuren en vooruitgang. Het past je routines voortdurend aan om je resultaten te maximaliseren en je gemotiveerd te houden.",
  "faq.d5.question": "Ik zoek een app om gezonde gewoonten te creëren en te beheren.",
  "faq.d5.answer":
    "ProgressMade.ai is de ideale app voor het creëren en beheren van gezonde gewoonten. De AI-gedreven aanpak helpt je gewoonten in te stellen, bij te houden en te verfijnen, waardoor het gemakkelijker dan ooit wordt om een gezondere levensstijl op te bouwen.",
  "faq.d6.question": "Hoe kan een app me helpen consistenter te zijn met mijn gezondheid?",
  "faq.d6.answer":
    "ProgressMade.ai helpt je consistent te blijven door gepersonaliseerde routines, tijdige herinneringen en motiverende feedback te bieden. De AI leert van je gedrag en past je plan aan om je betrokken te houden en vooruitgang naar je doelen te boeken.",

  // FAQ Questions & Answers - Features
  "faq.f1.question": "Hoe gebruikt ProgressMade.ai AI om routines in te stellen?",
  "faq.f1.answer":
    "ProgressMade.ai gebruikt AI om je doelen, voorkeuren en vooruitgang te analyseren, en genereert vervolgens dagelijkse routines die specifiek voor jou zijn afgestemd. De routines evolueren naarmate je de app gebruikt, zodat ze effectief en haalbaar blijven.",
  "faq.f2.question": "Kan ProgressMade.ai een gepersonaliseerd gezondheidsplan voor me maken?",
  "faq.f2.answer":
    "Ja, ProgressMade.ai creëert een gepersonaliseerd gezondheidsplan door je unieke behoeften en doelen te begrijpen. De AI maakt routines en gewoonten die bij je levensstijl passen, waardoor je gezondheidsreis echt geïndividualiseerd wordt.",
  "faq.f3.question": "Houdt de app mijn vooruitgang bij voor verschillende gewoonten?",
  "faq.f3.answer":
    "ProgressMade.ai houdt je vooruitgang bij voor al je gewoonten en biedt duidelijke inzichten en visualisaties. Dit helpt je je verbeteringen in de tijd te zien en gebieden voor verdere groei te identificeren.",
  "faq.f4.question": "Kan ik herinneringen instellen voor mijn routines?",
  "faq.f4.answer":
    "Absoluut! ProgressMade.ai stelt je in staat om aangepaste herinneringen voor je routines in te stellen, zodat je nooit een stap mist op je gezondheidsreis.",
  "faq.f5.question": "Biedt het suggesties voor nieuwe gezonde gewoonten?",
  "faq.f5.answer":
    "Ja, de AI in ProgressMade.ai suggereert nieuwe gezonde gewoonten op basis van je vooruitgang en interesses, waardoor je je welzijn voortdurend kunt verbeteren.",
  "faq.f6.question": "Kan ik ProgressMade.ai integreren met andere fitnesstrackers of apps?",
  "faq.f6.answer":
    "ProgressMade.ai is ontworpen om samen te werken met je favoriete fitnesstrackers en gezondheidsapps, waardoor het gemakkelijk is om je gegevens te synchroniseren en een compleet overzicht van je gezondheid te krijgen.",
  "faq.f7.question": "Hoe gaat de app om met het missen van een routine?",
  "faq.f7.answer":
    "Als je een routine mist, zal de AI van ProgressMade.ai je plan aanpassen en zachte herinneringen en aanmoediging bieden, waardoor je weer op koers komt zonder schuldgevoel.",
  "faq.f8.question": "Biedt het motivatie of feedback?",
  "faq.f8.answer":
    "ProgressMade.ai biedt motiverende feedback en viert je prestaties, waardoor je geïnspireerd en betrokken blijft gedurende je gezondheidsreis.",
  "faq.f9.question":
    "Kan ik de soorten gewoonten die ik wil bijhouden aanpassen (bijv. beweging, voeding, slaap, mindfulness)?",
  "faq.f9.answer":
    "Ja, ProgressMade.ai laat je de gewoonten die je bijhoudt volledig aanpassen, inclusief beweging, voeding, slaap, mindfulness en meer. De app past zich aan je unieke gezondheitsprioriteiten aan.",

  // FAQ Questions & Answers - Personalization
  "faq.p1.question": "Hoe leert de AI over mijn gewoonten en voorkeuren?",
  "faq.p1.answer":
    "De AI in ProgressMade.ai leert van je dagelijkse invoer, vooruitgang en feedback. Na verloop van tijd bouwt het een gedetailleerd begrip op van je gewoonten en voorkeuren, waardoor het steeds meer gepersonaliseerde aanbevelingen kan doen.",
  "faq.p2.question": "Kan de AI mijn routine aanpassen op basis van mijn vooruitgang of stemming?",
  "faq.p2.answer":
    "Ja, de AI van ProgressMade.ai past je routines aan op basis van je vooruitgang en zelfs je stemming, zodat je plan altijd past bij je huidige behoeften en je gemotiveerd houdt.",
  "faq.p3.question": "Biedt de AI inzichten in mijn gewoontepatronen?",
  "faq.p3.answer":
    "ProgressMade.ai biedt uitvoerbare inzichten in je gewoontepatronen, waardoor je begrijpt wat werkt en waar je kunt verbeteren voor betere resultaten.",
  "faq.p4.question":
    "Kan de AI me helpen identificeren waarom ik moeite heb met bepaalde gewoonten?",
  "faq.p4.answer":
    "Ja, de AI analyseert je gegevens om obstakels te identificeren en biedt praktische oplossingen, waardoor het gemakkelijker wordt om uitdagingen te overwinnen en blijvende gewoonten op te bouwen.",
  "faq.p5.question":
    "Hoe zorgt de AI ervoor dat de routines die het voorstelt haalbaar voor me zijn?",
  "faq.p5.answer":
    "De AI van ProgressMade.ai houdt rekening met je levensstijl, voorkeuren en vooruitgang om routines voor te stellen die realistisch en haalbaar zijn, waardoor je vertrouwen en consistentie opbouwt.",

  // FAQ Questions & Answers - Benefits
  "faq.b1.question": "Hoe kan ProgressMade.ai me helpen consistenter te zijn?",
  "faq.b1.answer":
    "ProgressMade.ai houdt je consistent door gepersonaliseerde routines, herinneringen en motiverende feedback te bieden, allemaal afgestemd op je unieke reis.",
  "faq.b2.question": "Zal deze app me helpen mijn gezondheidsdoelen sneller te bereiken?",
  "faq.b2.answer":
    "Ja, ProgressMade.ai versnelt je vooruitgang door AI te gebruiken om je routines te optimaliseren en je gefocust te houden op wat het belangrijkst is, waardoor je je gezondheidsdoelen efficiënter bereikt.",
  "faq.b3.question": "Hoe kan een AI-routine me helpen blijvende gewoonten op te bouwen?",
  "faq.b3.answer":
    "AI-routines in ProgressMade.ai passen zich aan je behoeften en vooruitgang aan, waardoor het gemakkelijker wordt om bij nieuwe gewoonten te blijven en ze om te zetten in blijvende levensstijlveranderingen.",
  "faq.b4.question":
    "Wat zijn de voordelen van het gebruik van een AI-aangedreven gewoontetracker?",
  "faq.b4.answer":
    "Een AI-aangedreven gewoontetracker zoals ProgressMade.ai biedt gepersonaliseerde begeleiding, past zich aan je vooruitgang aan en biedt inzichten die je helpen betere resultaten te behalen dan generieke apps.",
  "faq.b5.question":
    "Zal het gebruik van ProgressMade.ai stress verminderen die gerelateerd is aan het beheren van mijn gezondheid?",
  "faq.b5.answer":
    "Ja, ProgressMade.ai vereenvoudigt gezondheidsbeheer door je routines te organiseren en duidelijke, uitvoerbare stappen te bieden, waardoor stress wordt verminderd en je reis plezierig wordt.",

  // FAQ Questions & Answers - Ease of Use
  "faq.e1.question": "Is ProgressMade.ai gemakkelijk te gebruiken?",
  "faq.e1.answer":
    "ProgressMade.ai is ontworpen voor eenvoud en gebruiksgemak, met een intuïtieve interface die het beheren van je gezondheidsroutines moeiteloos maakt voor iedereen.",
  "faq.e2.question": "Is de app beschikbaar op iOS en Android?",
  "faq.e2.answer":
    "ProgressMade.ai is beschikbaar op zowel iOS als Android, zodat je je gezondheidsroutines overal kunt beheren waar je bent.",
  "faq.e3.question": "Is er een gratis proefperiode of gratis versie?",
  "faq.e3.answer":
    "Ja, ProgressMade.ai biedt een gratis versie met essentiële functies, zodat je kosteloos kunt beginnen met het verbeteren van je gezondheid. Upgrade naar Pro voor geavanceerde AI-inzichten en onbeperkte routines.",
  "faq.e4.question": "Wat zijn de kosten van de app?",
  "faq.e4.answer":
    "ProgressMade.ai biedt een gratis plan en betaalbare Pro-opties. Bezoek onze prijzenpagina voor de laatste prijsdetails en kies het plan dat bij je behoeften past.",
  "faq.e5.question": "Hoe worden gebruikersgegevens behandeld en is het privé?",
  "faq.e5.answer":
    "Je privacy is onze topprioriteit. ProgressMade.ai gebruikt encryptie van ondernemingsniveau en strikte privacybeleid om je gegevens veilig en vertrouwelijk te houden.",

  // FAQ Questions & Answers - Pain Points
  "faq.u1.question": "Ik heb moeite met consistentie. Kan ProgressMade.ai helpen?",
  "faq.u1.answer":
    "Absoluut! ProgressMade.ai is ontworpen om je te helpen consistentie op te bouwen met gepersonaliseerde routines, herinneringen en motiverende ondersteuning afgestemd op je behoeften.",
  "faq.u2.question": "Ik weet niet waar ik moet beginnen met het opbouwen van een gezonde routine.",
  "faq.u2.answer":
    "ProgressMade.ai begeleidt je stap voor stap, waardoor het gemakkelijk wordt om gezonde routines op te bouwen, zelfs als je een complete beginner bent.",
  "faq.u3.question":
    "Ik voel me overweldigd door al het gezondheidsadvies daarbuiten. Kan de app het vereenvoudigen?",
  "faq.u3.answer":
    "Ja, ProgressMade.ai doorprikt de ruis door duidelijke, gepersonaliseerde routines en uitvoerbare stappen te bieden, zodat je je kunt concentreren op wat voor jou werkt.",
  "faq.u4.question": "Ik verlies gemakkelijk motivatie. Kan de app me betrokken houden?",
  "faq.u4.answer":
    "ProgressMade.ai houdt je betrokken met motiverende feedback, voortgangsmonitoring en adaptieve routines die evolueren met je reis.",
  "faq.u5.question": "Ik heb een drukke agenda. Kan de app een routine creëren die past?",
  "faq.u5.answer":
    "Ja, ProgressMade.ai creëert routines die passen bij je drukke levensstijl, zodat je vooruitgang kunt boeken, ongeacht hoe hectisch je schema is.",

  // Footer
  "footer.downloadAppStore": "Download in de App Store",
  "footer.downloadGooglePlay": "Download via Google Play",
  "footer.aboutUs": "Over Ons",
  "footer.contact": "Contact",
  "footer.pricing": "Prijzen",
  "footer.blog": "Blog",
  "footer.changelog": "Changelog",
  "footer.newsletter": "Nieuwsbrief",
  "footer.compare": "Vergelijken",
  "footer.affiliateProgram": "Affiliate Programma",
  "footer.tools": "Tools",
  "footer.iphoneApp": "iPhone App",
  "footer.androidApp": "Android App",
  "footer.webApp": "Web App",
  "footer.progressCalendars": "Progress Calendars",
  "footer.features": "Functies",
  "footer.healthCalendar": "Kalender",
  "footer.healthRoutines": "Routines",
  "footer.healthGoals": "Doelen",
  "footer.healthThemes": "Thema's",
  "footer.copyright": "© {year} {appName}. Alle rechten voorbehouden.",
  "footer.privacyPolicy": "Privacybeleid",
  "footer.termsOfService": "Servicevoorwaarden",
  "footer.googlePlayTrademark":
    "Google Play en het Google Play-logo zijn handelsmerken van Google LLC.",
  "footer.instagramProfile": "Instagram Profiel",
  "footer.whatsappCommunity": "WhatsApp Community",
  "footer.linkedinProfile": "LinkedIn Profiel",
  "footer.tiktokProfile": "TikTok Profiel",
  "footer.xProfile": "X (voorheen Twitter) Profiel",

  // Common
  "common.error": "Fout",
  "common.success": "Succes",
  "common.and": "en",

  // Settings - Notifications
  "settings.notifications.title": "Notificaties",
  "settings.notifications.enable_all": "Alle meldingstypen inschakelen",
  "settings.notifications.disable_all": "Alle meldingstypen uitschakelen",
  "settings.notifications.no_fcm_token.title": "Geen FCM Token",
  "settings.notifications.no_fcm_token.description":
    "Je hebt notificaties ingeschakeld, maar je hebt geen FCM token. Schakel notificaties opnieuw in.",
  "settings.notifications.todays_routines.title": "Routines van Vandaag",
  "settings.notifications.todays_routines.description":
    "Stuur me 's ochtends (8:00 lokale tijd) een samenvatting van de routines van vandaag.",
  "settings.notifications.routine_reminder.title": "Routine Herinneringen",
  "settings.notifications.routine_reminder.description":
    "Stuur me een paar minuten voordat een geplande routine begint een melding.",
  "settings.notifications.show_preview": "Toon Voorbeeld",
  "settings.notifications.update_error":
    "Kan notificatie instellingen niet bijwerken. Probeer het opnieuw.",
  "settings.notifications.update_single_error":
    "Kan '{label}' niet bijwerken. Probeer het opnieuw.",
  "settings.notifications.example.todays_routines.name": "Routines van Vandaag",
  "settings.notifications.example.todays_routines.description":
    "Maak je klaar voor: Ochtendrun, Groene Smoothie, Ontspanningsroutine.",
  "settings.notifications.example.todays_routines.time": "8:00",
  "settings.notifications.example.routine_reminder.name": "Ochtendrun Herinnering",
  "settings.notifications.example.routine_reminder.description":
    "Je Ochtendrun begint over 5 minuten!",
  "settings.notifications.example.routine_reminder.time": "9:55",

  // Settings - Calendar
  "settings.calendar.time_format": "Tijdformaat",
  "settings.calendar.time_format.placeholder": "Kies je tijdformaat",
  "settings.calendar.time_format.12h": "12-uurs (8:00 AM)",
  "settings.calendar.time_format.24h": "24-uurs (08:00)",
  "settings.calendar.week_starts_on": "Week Begint Op",
  "settings.calendar.week_starts_on.placeholder": "Kies je weekstart",
  "settings.calendar.week_starts_on.sunday": "Zondag",
  "settings.calendar.week_starts_on.monday": "Maandag",
  "settings.calendar.timezone": "Tijdzone",
  "settings.calendar.timezone.placeholder": "Selecteer je tijdzone",
  "settings.calendar.timezone.description":
    "We gebruiken dit voor nauwkeurige planning en herinneringen.",
  "settings.calendar.save_settings": "Instellingen Opslaan",
  "settings.calendar.update_error":
    "Kan je kalender instellingen niet bijwerken. Probeer het opnieuw.",
  "settings.calendar.update_success": "Je kalender instellingen zijn succesvol bijgewerkt.",

  // Auth Dialogs
  "auth.register.title": "Registreren",
  "auth.register.description":
    "Meld je gratis aan en begin vandaag nog met het bouwen van je perfecte gezondheidsroutines!",
  "auth.register.continue_with_email": "Doorgaan met E-mail",
  "auth.login.title": "Inloggen",
  "auth.login.description": "Welkom terug! Duik terug in je routines en blijf vooruitgang boeken.",
  "auth.login.continue_with_email": "Inloggen met E-mail",
  "auth.forgot_password.title": "Wachtwoord Vergeten",
  "auth.forgot_password.description":
    "Voer je e-mailadres in om een link voor het resetten van je wachtwoord te ontvangen.",

  // Auth Buttons
  "auth.buttons.continue_with_apple": "Doorgaan met Apple",
  "auth.buttons.login_with_apple": "Inloggen met Apple",
  "auth.buttons.continue_with_google": "Doorgaan met Google",
  "auth.buttons.login_with_google": "Inloggen met Google",
  "auth.buttons.continue_with_email": "Doorgaan met E-mail",
  "auth.buttons.login_with_email": "Inloggen met E-mail",
  "auth.buttons.apple_signin_failed": "Apple inloggen mislukt",
  "auth.buttons.google_signin_failed": "Google inloggen mislukt",

  // Legal Links
  "legal.agreement_text": "Door verder te gaan, stemt u in met de voorwaarden van {appName}",
  "legal.terms_of_service": "Servicevoorwaarden",
  "legal.privacy_policy": "Privacybeleid",
  "legal.read_our": "Lees ons",

  // Contact Form
  "contact.feedbackDialog.title": "Feedback",
  "contact.feedback_description":
    "We verbeteren op basis van je feedback. Je kunt ons ook direct e-mailen op",
  "contact.your_email": "Je E-mailadres",
  "contact.email_placeholder": "jouw@email.com",
  "contact.message": "Bericht",
  "contact.message_placeholder": "Wat wil je ons vertellen?",
  "contact.submit_message": "Bericht Versturen",
  "contact.success_title": "Succes",
  "contact.success_description": "Je bericht is verzonden. We nemen binnenkort contact met je op!",
  "contact.error_title": "Fout",
  "contact.error_description":
    "Er is een fout opgetreden bij het verzenden van je bericht. Probeer het opnieuw.",
  "contact.message_min_length": "Bericht moet minimaal 5 tekens bevatten",
  "contact.email_invalid": "Voer een geldig e-mailadres in",

  // Register Form
  "register.your_name": "Je naam",
  "register.name_placeholder": "Volledige naam...",
  "register.name_description": "Dit is je openbare weergavenaam.",
  "register.email": "E-mail",
  "register.email_placeholder": "jouw@email.com",
  "register.password": "Wachtwoord",
  "register.password_placeholder": "****",
  "register.register_button": "Registreren",
  "register.already_have_account": "Heb je al een account? Inloggen",
  "register.name_min_length": "Je naam moet minimaal 2 tekens lang zijn",
  "register.email_invalid": "Ongeldig e-mailadres",
  "register.password_min_length": "Wachtwoord moet minimaal 8 tekens lang zijn",
  "register.registration_failed":
    "Registratie mislukt. Controleer je gegevens of probeer in te loggen.",

  // Profile Form
  "profile.your_name": "Je naam",
  "profile.name_placeholder": "Je naam",
  "profile.name_description": "Dit is de naam die wordt weergegeven op je profiel en in e-mails.",
  "profile.interface_language": "Taal",
  "profile.interface_language_placeholder": "Selecteer je gewenste taal",
  "profile.interface_language_description": "Dit is de taal voor de interface en navigatie.",
  "profile.ai_model_language": "AI Model Taal",
  "profile.ai_model_language_placeholder": "Selecteer je gewenste AI taal",
  "profile.ai_model_language_description":
    "Dit is de taal die de AI zal gebruiken bij communicatie met jou en het genereren van antwoorden.",
  "profile.allow_marketing_mail": "E-mails",
  "profile.allow_marketing_mail_description":
    "Ontvang updates over nieuwe functies, gezondheidstips en content van ProgressMade.",
  "profile.update_profile": "Profiel Bijwerken",
  "profile.update_error": "Kan je profiel niet bijwerken. Probeer het opnieuw.",
  "profile.update_success": "Je profiel is succesvol bijgewerkt.",
  "profile.name_min_length": "Volledige naam moet minimaal 2 tekens lang zijn",
  "profile.language_required": "Selecteer een taal",
  "profile.ai_language_required": "Selecteer een taal voor de AI",

  // Newsletter Form
  "newsletter.your_name": "Je naam",
  "newsletter.name_placeholder": "Je naam",
  "newsletter.email": "E-mail",
  "newsletter.email_placeholder": "Voer je e-mailadres in...",
  "newsletter.join_newsletter": "Aanmelden voor Nieuwsbrief",
  "newsletter.already_subscribed": "Al Geabonneerd",
  "newsletter.already_subscribed_description":
    "Dit e-mailadres is al geabonneerd op onze nieuwsbrief.",
  "newsletter.subscription_failed": "Abonnement Mislukt",
  "newsletter.subscription_failed_description": "Er is iets misgegaan. Probeer het opnieuw.",
  "newsletter.subscribed": "Geabonneerd!",
  "newsletter.subscribed_description":
    "Bedankt voor je aanmelding! Controleer je inbox voor updates.",
  "newsletter.name_required": "Naam is verplicht",
  "newsletter.email_invalid": "Voer een geldig e-mailadres in",

  // Pro Component
  "pro.title": "ProgressMade Health Pro",
  "pro.subtitle": "Ontgrendel Je Pad naar Betere Gezondheid en Energie",
  "pro.subtitle_personalized": "{name}, ontgrendel je pad naar betere gezondheid en energie",
  "pro.monthly": "Maandelijks",
  "pro.yearly": "Jaarlijks",
  "pro.save_percentage": "Bespaar {percentage}%",
  "pro.per_day": "Slechts {price} per dag",
  "pro.billed_annually": "{price} jaarlijks gefactureerd",
  "pro.secure_payment": "Veilige betaling mogelijk gemaakt door {provider}",
  "pro.continue_with_apple_pay": "Ga verder met Apple Pay",
  "pro.continue_with_stripe": "Ga verder met Stripe",
  "pro.continue_with_google_play": "Ga verder met Google Play",
  "pro.restore_purchases": "Herstel aankopen",
  "pro.error_creating_checkout": "Fout bij het maken van checkout sessie",
  "pro.no_purchases_to_restore": "Geen aankopen om te herstellen",

  // Sidebar
  "sidebar.today": "Vandaag",
  "sidebar.health_areas": "Gezondheidsthema's",
  "sidebar.goals": "Doelen",
  "sidebar.routines": "Routines",
  "sidebar.calendar": "Kalender",
  "sidebar.library": "Bibliotheek",
  "sidebar.pro_member": "Pro Lid",
  "sidebar.free_member": "Gratis Lid",
  "sidebar.notification_settings": "Notificatie instellingen",
  "sidebar.calendar_settings": "Kalender instellingen",
  "sidebar.profile": "Profiel",
  "sidebar.account": "Account",
  "sidebar.log_out": "Uitloggen",
  "sidebar.go_to_home": "Ga naar Home",
  "sidebar.share_with_friend": "Deel met een vriend",
  "sidebar.upgrade_to_pro": "Upgrade naar Pro",
  "sidebar.provide_feedback": "Feedback",
  "sidebar.add_routine": "Nieuwe Routine",
  "sidebar.add_goal": "Nieuw Doel",
  "sidebar.add_health_area": "Nieuw Gezondheidsthema",
  "sidebar.edit_delete_more": "Bewerken, verwijderen en meer...",
  "sidebar.thanks_for_sharing": "Bedankt voor het delen!",
  "sidebar.friend_notified": "Je vriend is op de hoogte gebracht.",
  "sidebar.link_copied": "Link gekopieerd naar klembord!",
  "sidebar.share_link_description": "Je kunt deze link nu delen met een vriend.",
  "sidebar.unable_to_share": "Kan niet delen",
  "sidebar.copy_url_manually": "Kopieer de URL handmatig uit de adresbalk van je browser.",
  "sidebar.share_failed": "Delen mislukt",
  "sidebar.share_failed_description": "Probeer het opnieuw of kopieer de URL handmatig.",

  // Pricing
  "pricing.free.name": "Gratis",
  "pricing.free.description": "Begin je gezondheidsreis",
  "pricing.free.period": "voor altijd",
  "pricing.free.track_health_areas": "Volg maximaal {count} gezondheidsthema's",
  "pricing.free.track_goals": "Volg maximaal {count} doelen",
  "pricing.free.manage_routines": "Beheer maximaal {count} routines",
  "pricing.free.ai_suggestions": "Ontvang {count} AI-suggesties",
  "pricing.free.basic_insights": "Basis gezondheids inzichten en tracking",
  "pricing.free.core_tools": "Toegang tot kern gezondheidsverbetering tools",
  "pricing.pro.name": "Pro",
  "pricing.pro.description": "Ontgrendel je beste zelf met onbeperkte toegang en personalisatie",
  "pricing.pro.everything_free": "Alles in Gratis",
  "pricing.pro.unlimited_health_areas": "Onbeperkte Gezondheidsthema's",
  "pricing.pro.unlimited_goals": "Onbeperkte Doelen",
  "pricing.pro.unlimited_routines": "Onbeperkte Routines",
  "pricing.pro.unlimited_ai": "Onbeperkte AI-aangedreven inzichten en suggesties",
  "pricing.pro.advanced_analytics": "Geavanceerde analyses met gepersonaliseerde coaching",
  "pricing.pro.calendar_integration": "Volledige kalender integratie en planning",

  // Pricing Page
  "pricing.page.title": "Prijzen",
  "pricing.page.description":
    "Investeer in je {healthTransformation}. Krijg gepersonaliseerde begeleiding en geavanceerde tools om echte verbeteringen in je gezondheid en fitness te bereiken.",
  "pricing.page.health_transformation": "gezondheids transformatie",
  "pricing.page.monthly": "Maandelijks",
  "pricing.page.yearly": "Jaarlijks",
  "pricing.page.save_percentage": "Bespaar 35%",
  "pricing.page.get_started": "Aan de Slag",
  "pricing.page.summer_deal": "Zomer Komt Eraan Deal",
  "pricing.page.upgrade_to_pro": "Upgrade naar Pro",
  "pricing.page.billed_yearly": "(jaarlijks gefactureerd)",

  // Page Titles and Descriptions
  "pages.account.title": "Mijn Account",
  "pages.account.description": "Werk je e-mail bij, wijzig je wachtwoord of verwijder je account.",
  "pages.profile.title": "Mijn Profiel",
  "pages.profile.description": "Werk je persoonlijke informatie bij en pas je profiel aan.",
  "pages.calendar_settings.title": "Kalender Instellingen",
  "pages.calendar_settings.description":
    "Werk je kalender instellingen bij om je kalender accuraat en up-to-date te houden.",
  "pages.notification_settings.title": "Notificatie Instellingen",
  "pages.notification_settings.description":
    "Werk je notificatie instellingen bij om je notificaties accuraat en up-to-date te houden.",

  // Account Page Components
  "account.pro_status.title": "Pro Status",
  "account.pro_status.description": "Je huidige abonnementsstatus en factureringsinformatie.",
  "account.pro_status.status": "Status",
  "account.pro_status.plan": "Abonnement",
  "account.pro_status.next_billing_date": "Volgende factureringsdatum",
  "account.pro_status.pro_access_until": "Pro toegang tot",
  "account.pro_status.cancel_subscription": "Abonnement Opzeggen",
  "account.pro_status.status_pro": "Pro",
  "account.pro_status.status_pro_canceled": "Pro (Opgezegd)",
  "account.pro_status.status_free": "Gratis",
  "account.pro_status.plan_monthly": "Maandelijkse Facturering",
  "account.pro_status.plan_yearly": "Jaarlijkse Facturering",
  "account.pro_status.cancel_description":
    "Je pro toegang blijft actief tot het einde van je factureringsperiode.",
  "account.pro_status.cancel_confirm_description": "Dit zal je abonnement permanent opzeggen.",
  "account.pro_status.cancel_error":
    "We konden je abonnement niet opzeggen. Probeer het later opnieuw.",

  "account.usage_statistics.title": "Gebruiksstatistieken",
  "account.usage_statistics.description": "Je huidige gebruiksstatistieken.",
  "account.usage_statistics.remove_limits": "Verwijder alle limieten met Pro",
  "account.usage_statistics.upgrade_to_pro": "Upgrade naar Pro",
  "account.usage_statistics.health_areas": "Gezondheidsthema's",
  "account.usage_statistics.goals": "Doelen",
  "account.usage_statistics.routines": "Routines",
  "account.usage_statistics.ai_suggestions": "AI Suggesties",

  "account.update_email.title": "E-mail bijwerken",
  "account.update_email.description":
    "Wijzig je e-mail om je account gekoppeld te houden aan het juiste contact.",

  "account.update_password.title": "Wachtwoord bijwerken",
  "account.update_password.description":
    "Stel een sterk wachtwoord in om je account veilig te houden. Zorg ervoor dat het uniek is en gemakkelijk voor jou te onthouden.",
  "account.update_password.send_reset_email": "Reset E-mail Versturen",
  "account.update_password.reset_sent_title": "Wachtwoord reset link verzonden!",
  "account.update_password.reset_sent_description":
    "Als je een account hebt, hebben we je een wachtwoord reset link gestuurd.",
  "account.update_password.reset_error_title": "Oeps! Er is iets misgegaan.",
  "account.update_password.reset_error_description":
    "We konden de wachtwoord reset e-mail niet versturen. Probeer het later opnieuw.",

  "account.delete_account.title": "Account Verwijderen",
  "account.delete_account.description":
    "Verwijder permanent je account en alle gerelateerde gegevens zoals je routines.",
  "account.delete_account.button": "Account Verwijderen",
  "account.delete_account.success_title": "Succes",
  "account.delete_account.success_description": "Je account is verwijderd.",
  "account.delete_account.error_title": "Fout",
  "account.delete_account.error_description":
    "Kan je account niet verwijderen. Probeer het opnieuw.",

  // Profile Page Components
  "profile.form_card.title": "Profiel bijwerken",
  "profile.form_card.description": "Werk je profielinformatie bij.",
  "profile.avatar_card.title": "Profiel Avatar",
  "profile.avatar_card.description": "Selecteer je profiel avatar uit de onderstaande opties.",
  "profile.avatar_card.change_button": "Avatar Wijzigen",
  "profile.avatar_card.select_title": "Selecteer Avatar",
  "profile.avatar_card.error_title": "Fout",
  "profile.avatar_card.error_description": "Kan je avatar niet bijwerken. Probeer het opnieuw.",
  "profile.avatar_card.no_user_error": "Geen gebruikers-ID gevonden. Probeer het opnieuw.",

  // Command Menu
  "command_menu.open_command_menu": "Commandomenu openen",
  "command_menu.search_placeholder": "Zoeken...",
  "command_menu.search_input_placeholder": "Typ een commando of zoek...",
  "command_menu.no_results": "Geen resultaten gevonden.",
  "command_menu.links": "Links",
  "command_menu.commands": "Commando's",
  "command_menu.account": "Account",
  "command_menu.theme": "Thema",
  "command_menu.social": "Sociaal",
  "command_menu.progressmade_health_pro": "ProgressMade Health Pro",
  "command_menu.get_help_or_share_contact": "Hulp Krijgen of Contact Delen",
  "command_menu.rate_us": "Beoordeel Ons",
  "command_menu.light": "Licht",
  "command_menu.dark": "Donker",
  "command_menu.join_whatsapp_community": "WhatsApp Community",
  "command_menu.linkedin": "LinkedIn",
  "command_menu.x": "X",
  "command_menu.instagram": "Instagram",
  "command_menu.tiktok": "TikTok",

  // Dashboard
  "dashboard.good_morning": "Goedemorgen",
  "dashboard.good_afternoon": "Goedemiddag",
  "dashboard.good_evening": "Goedenavond",
  "dashboard.routines_for_today": "Routines voor vandaag",
  "dashboard.upcoming_routines": "Aankomende routines",
  "dashboard.completed_routines": "Voltooide routines",
  "dashboard.weekly_progress": "Weekstatus",
  "dashboard.share": "Delen",
  "dashboard.completed": "Voltooid",
  "dashboard.remaining": "Resterend",
  "dashboard.routines": "Routines",

  // Calendar Navigation
  "calendar.nav.day": "Dag",
  "calendar.nav.week": "Week",
  "calendar.nav.month": "Maand",
  "calendar.nav.list": "Lijst",
  "calendar.nav.today": "Vandaag",
  "calendar.nav.previous": "Vorige",
  "calendar.nav.next": "Volgende",

  // Calendar List View
  "calendar.list_view.day_complete": "Dag Voltooid",

  // Forms
  "forms.email": "E-mail",
  "forms.password": "Wachtwoord",
  "forms.email_placeholder": "jouw@email.com",
  "forms.password_placeholder": "****",
  "forms.login": "Inloggen",
  "forms.reset_password": "Wachtwoord Resetten",
  "forms.forgot_password_link": "Wachtwoord vergeten?",
  "forms.invalid_email": "Ongeldig e-mailadres",
  "forms.password_required": "Wachtwoord is verplicht",
  "forms.invalid_email_or_password": "Ongeldig e-mailadres of wachtwoord",
  "forms.login_error": "Kan niet inloggen. Probeer het opnieuw.",
  "forms.login_error_generic":
    "Er is een fout opgetreden tijdens het inloggen. Probeer het opnieuw.",

  // Global Error
  "global_error.title": "Er is iets misgegaan",
  "global_error.description":
    "Het spijt ons, maar er is een fout opgetreden bij het laden van deze pagina.",
  "global_error.team_notified": "Ons team is op de hoogte gebracht en we werken aan een oplossing.",
  "global_error.refresh": "Herladen",

  // Auth Pages
  "auth.login.page_title": "Inloggen",
  "auth.login.page_description": "Log in op je account om te beginnen.",
  "auth.register.page_title": "Registreren met E-mail",
  "auth.register.page_description": "Maak een account aan om te beginnen.",

  // Newsletter Page
  "newsletter.page.title": "Aanmelden voor Nieuwsbrief",
  "newsletter.page.description": "Je ontvangt regelmatige updates over {appName}.",

  // Confirm Delete Dialog
  "confirm_delete.title": "Weet je het zeker?",
  "confirm_delete.description":
    "Dit zal je account permanent verwijderen en je gegevens van de servers verwijderen.",
  "confirm_delete.cancel": "Annuleren",
  "confirm_delete.confirm": "Bevestigen",

  // Auth Error Page
  "auth_error.title": "Authenticatiefout",
  "auth_error.description": "We hebben een probleem ondervonden met je inlogpoging",
  "auth_error.problem_description":
    "Er was een probleem bij het authenticeren van je account. Dit kan komen door:",
  "auth_error.reason_session_expired": "Je authenticatiesessie is verlopen.",
  "auth_error.reason_provider_unavailable":
    "De authenticatieprovider (Google of Apple) is tijdelijk niet beschikbaar.",
  "auth_error.reason_permission_denied": "Je hebt toestemming geweigerd voor de gevraagde toegang.",
  "auth_error.reason_network_issue": "Er was een netwerkverbindingsprobleem.",
  "auth_error.help_text":
    "Probeer opnieuw in te loggen. Als het probleem aanhoudt, neem contact op met ons ondersteuningsteam voor hulp.",
  "auth_error.go_home": "Ga naar Home",
  "auth_error.contact_support": "Contact Ondersteuning",

  // Custom Error Component
  "custom_error.title": "Fout",
  "custom_error.description": "Er is een fout opgetreden bij het ophalen van gegevens.",
  "custom_error.unknown_error": "Onbekende fout",

  // Dashboard Circle
  "dashboard.circle.todays_progress": "Dagstatus",
  "dashboard.circle.progress_tooltip":
    "Toont het percentage van routine stappen die je vandaag hebt voltooid. Voltooi alle stappen in je routines om 100% te bereiken.",
  "dashboard.circle.progress_title": "Voortgangscirkel",
  "dashboard.circle.steps_completed": "{completed} van {total} stappen",
  "dashboard.circle.routines_completed": "{completed} van {total} routines",
  "dashboard.circle.all_done": "Alles voltooid!",
  "dashboard.circle.keep_going": "Ga door!",
  "dashboard.circle.switch_to_weekly": "Bekijk Week",
  "dashboard.circle.switch_to_daily": "Bekijk Dag",

  // Dashboard Goals
  "dashboard.goals.other_goals": "Andere Doelen",
  "dashboard.goals.no_goals_in_health_area": "Geen doelen toegewezen aan dit gezondheidsthema",

  // Sort Dropdown
  "sort.by_health_area": "Sorteer op Thema",
  "sort.manual": "Handmatig Sorteren",

  // New Resource Card
  "new_resource.health_area.title": "Nieuw Gezondheidsthema",
  "new_resource.health_area.description":
    "Maak een nieuw gezondheidsthema aan om je doelen en routines te organiseren.",
  "new_resource.goal.title": "Nieuw Doel",
  "new_resource.goal.description":
    "Maak een nieuw doel aan om je voortgang en prestaties bij te houden.",
  "new_resource.routine.title": "Nieuwe Routine",
  "new_resource.routine.description":
    "Maak een nieuwe routine aan om gezonde gewoonten en consistentie op te bouwen.",

  // Goal Card
  "goal_card.added": "Toegevoegd",
  "goal_card.add_goal": "Doel Toevoegen",
  "goal_card.goal_added_tooltip": "Doel is toegevoegd aan je account",

  // Routine Card
  "routine_card.added": "Toegevoegd",
  "routine_card.add_routine": "Routine Toevoegen",
  "routine_card.routine_added_tooltip": "Routine is toegevoegd aan je account",
  "routine_card.daily": "Dagelijks",
  "routine_card.planned_for": "Je hebt deze routine gepland voor {days}.",
  "routine_card.steps": "stappen",
  "routine_card.step": "stap",

  // Manage Resource
  "manage_resource.add": "Toevoegen",
  "manage_resource.edit": "Bewerken",
  "manage_resource.create_description":
    "Definieer je nieuwe {resource} en het wordt toegevoegd aan je voortgangsdashboard.",
  "manage_resource.update_description": "Werk je {resource} bij.",

  // Manage Health Area
  "manage_health_area.add_title": "Gezondheidsthema Toevoegen",
  "manage_health_area.edit_title": "Gezondheidsthema Bewerken",
  "manage_health_area.create_description":
    "Definieer je nieuwe gezondheidsthema en het wordt toegevoegd aan je voortgangsdashboard.",
  "manage_health_area.update_description": "Werk je gezondheidsthema bij.",

  // Manage Goal
  "manage_goal.add_title": "Doel Toevoegen",
  "manage_goal.edit_title": "Doel Bewerken",
  "manage_goal.create_description":
    "Definieer je nieuwe doel en het wordt toegevoegd aan je voortgangsdashboard.",
  "manage_goal.update_description": "Werk je doel bij.",

  // Manage Routine
  "manage_routine.add_title": "Routine Toevoegen",
  "manage_routine.edit_title": "Routine Bewerken",
  "manage_routine.create_description":
    "Definieer je nieuwe routine en het wordt toegevoegd aan je voortgangsdashboard.",
  "manage_routine.update_description": "Werk je routine bij.",

  // Forgot Password Page
  "forgot_password.page_title": "Wachtwoord vergeten?",
  "forgot_password.page_description": "Voer je e-mailadres in om je wachtwoord te resetten.",

  // Blog Detail
  "blog.back_to_overview": "Terug naar Overzicht",

  // Hook Error Messages
  "hooks.error.failed_suggest_goal": "Kan doel niet voorstellen",
  "hooks.error.suggest_goal_description": "Probeer het opnieuw of maak handmatig een doel aan.",
  "hooks.error.failed_suggest_routine": "Kan routine niet voorstellen",
  "hooks.error.suggest_routine_description":
    "Probeer het opnieuw of maak handmatig een routine aan.",
  "hooks.error.failed_suggest_steps": "Kan stappen niet voorstellen",
  "hooks.error.suggest_steps_description": "Probeer het opnieuw of voeg handmatig stappen toe.",
  "hooks.error.updating_goals_order": "Fout bij bijwerken van doelvolgorde",
  "hooks.error.updating_routines_order": "Fout bij bijwerken van routinevolgorde",
  "hooks.error.logout_issue": "Er was een probleem bij het uitloggen. Probeer het opnieuw.",
  "hooks.error.purchase_failed": "Aankoop Mislukt",
  "hooks.error.purchase_request_error": "Fout bij verzenden van aankoopverzoek",
  "hooks.error.notifications_blocked": "Notificaties zijn geblokkeerd",
  "hooks.error.enable_notifications_browser": "Schakel notificaties in via je browserinstellingen",
  "hooks.error.failed_add_resource": "Kan {resource} niet toevoegen",
  "hooks.error.failed_update_resource": "Kan {resource} niet bijwerken",
  "hooks.error.failed_delete_resource": "Kan {resource} niet verwijderen",
  "hooks.error.no_resource_id": "Geen resource-ID gevonden voor bijwerken",
  "hooks.success.deleted_resource": "Je hebt {title} verwijderd",

  // Resource Actions
  "resource_actions.edit": "{resource} Bewerken",
  "resource_actions.delete": "{resource} Verwijderen",
  "resource_actions.add_goal": "Doel Toevoegen",
  "resource_actions.add_routine": "Routine Toevoegen",
  "resource_actions.suggest_goal": "Doel Voorstellen",
  "resource_actions.suggest_routine": "Routine Voorstellen",
  "resource_actions.generating": "Genereren...",
  "resource_actions.generating_goal": "Doel Genereren...",
  "resource_actions.generating_routine": "Routine Genereren...",

  // Resource Labels
  "resource_labels.health_area.singular": "Thema",
  "resource_labels.health_area.plural": "Thema's",
  "resource_labels.goal.singular": "Doel",
  "resource_labels.goal.plural": "Doelen",
  "resource_labels.routine.singular": "Routine",
  "resource_labels.routine.plural": "Routines",

  // Theme Switcher
  "theme.toggle": "Thema wisselen",

  // Search Input
  "search_input.select": "Selecteer {resource}...",
  "search_input.selected": "{count} {resource} geselecteerd",
  "search_input.search_placeholder": "Zoek {resource}...",
  "search_input.no_results": "Geen {resource} gevonden.",

  // Items Input
  "items_input.title": "Titel",
  "items_input.title_placeholder": "Voer {itemType} titel in",
  "items_input.description": "Beschrijving",
  "items_input.description_placeholder": "Voer {itemType} beschrijving in (optioneel)",
  "items_input.add": "Toevoegen",
  "items_input.edit": "Bewerken",
  "items_input.add_item": "{itemType} toevoegen",
  "items_input.edit_item": "{itemType} bewerken",
  "items_input.description_text": "Je {itemType} heeft {count} {itemTypePlural}.",
  "items_input.max_reached": "Maximum aantal {itemType} bereikt.",
  "items_input.dialog_description": "Voer een titel in voor deze {itemType}{context}{optional}.",

  // Items Input - Goal specific
  "items_input.goal.title": "Doel Titel",
  "items_input.goal.title_placeholder": "Voer doel titel in",
  "items_input.goal.description": "Doel Beschrijving",
  "items_input.goal.description_placeholder": "Voer doel beschrijving in (optioneel)",
  "items_input.goal.add": "Doel Toevoegen",
  "items_input.goal.edit": "Doel Bewerken",
  "items_input.goal.add_item": "Doel Toevoegen",
  "items_input.goal.edit_item": "Doel Bewerken",
  "items_input.goal.description_text":
    "Je doel heeft {count} {count, plural, one {item} other {items}}.",
  "items_input.goal.max_reached": "Maximum aantal doelen bereikt.",
  "items_input.goal.dialog_description": "Voer een titel in voor dit doel{optional}.",

  // Items Input - Routine specific
  "items_input.routine.title": "Routine Titel",
  "items_input.routine.title_placeholder": "Voer routine titel in",
  "items_input.routine.description": "Routine Beschrijving",
  "items_input.routine.description_placeholder": "Voer routine beschrijving in (optioneel)",
  "items_input.routine.add": "Routine Toevoegen",
  "items_input.routine.edit": "Routine Bewerken",
  "items_input.routine.add_item": "Routine Toevoegen",
  "items_input.routine.edit_item": "Routine Bewerken",
  "items_input.routine.description_text":
    "Je routine heeft {count} {count, plural, one {item} other {items}}.",
  "items_input.routine.max_reached": "Maximum aantal routines bereikt.",
  "items_input.routine.dialog_description": "Voer een titel in voor deze routine{optional}.",

  // Items Input - Step specific
  "items_input.step.title": "Stap Titel",
  "items_input.step.title_placeholder": "Voer stap titel in",
  "items_input.step.description": "Stap Beschrijving",
  "items_input.step.description_placeholder": "Voer stap beschrijving in (optioneel)",
  "items_input.step.add": "Stap Toevoegen",
  "items_input.step.edit": "Stap Bewerken",
  "items_input.step.add_item": "Stap Toevoegen",
  "items_input.step.edit_item": "Stap Bewerken",
  "items_input.step.description_text":
    "Je routine heeft {count} {count, plural, one {stap} other {stappen}}.",
  "items_input.step.max_reached": "Maximum aantal stappen bereikt.",
  "items_input.step.dialog_description":
    "Voer een titel in voor deze stap in je routine{optional}.",

  // Filtered Routines
  "filtered_routines.amazing_work": "Geweldig werk!",
  "filtered_routines.crushed_routines": "Je hebt al je routines vandaag voltooid.",
  "filtered_routines.keep_momentum": "Houd dit momentum vast!",
  "filtered_routines.incredible_progress": "Je maakt ongelooflijke vooruitgang",
  "filtered_routines.no_active_routines": "Geen actieve routines",
  "filtered_routines.create_new_routine":
    "Maak een nieuwe routine om je gezondheidsvoortgang bij te houden!",
  "filtered_routines.no_upcoming_routines":
    "Geen aankomende routines. Al je routines zijn vandaag actief.",
  "filtered_routines.no_completed_routines":
    "Geen voltooide routines. Al je routines zijn vandaag actief.",

  // Health Area Routines
  "health_area_routines.no_routines": "Geen routines toegewezen aan dit gezondheidsthema",

  // Routines Toggle
  "routines_toggle.today": "Vandaag",
  "routines_toggle.completed": "Voltooid",
  "routines_toggle.upcoming": "Aankomend",
  "routines_toggle.week": "Wekelijks",

  // Time Period Toggle
  "time_period_toggle.day": "Dag",
  "time_period_toggle.week": "Week",

  // Routine Form
  "routine_form.title": "Titel",
  "routine_form.title_placeholder": "Titel van je {mode} routine",
  "routine_form.title_required": "Titel is verplicht",
  "routine_form.new": "nieuwe",
  "routine_form.updated": "bijgewerkte",
  "routine_form.description": "Beschrijving",
  "routine_form.description_placeholder": "Geef details over je routine.",
  "routine_form.routine_steps": "Routine Stappen",
  "routine_form.suggesting_steps": "Stappen suggereren...",
  "routine_form.regenerate_steps": "Stappen genereren",
  "routine_form.suggest_steps": "Stappen suggereren",
  "routine_form.color": "Kleur",
  "routine_form.icon": "Icoon",
  "routine_form.tap_to_change_icon": "Tik om icoon te wijzigen",
  "routine_form.click_to_change_icon": "Klik om icoon te wijzigen",
  "routine_form.daily_routine": "Dagelijkse Routine",
  "routine_form.daily_routine_description": "Plan deze routine elke dag.",
  "routine_form.no_specific_time": "Geen Specifieke Tijd",
  "routine_form.no_specific_time_description": "Stel geen specifieke tijd in.",
  "routine_form.please_select_at_least_one_day": "Selecteer ten minste één dag",
  "routine_form.select_days_no_time":
    "Selecteer de dagen waarop je deze routine wilt plannen (geen specifieke tijden nodig).",
  "routine_form.select_days_with_time":
    "Selecteer de dagen en tijden waarop je deze routine wilt plannen.",
  "routine_form.planned_days_no_time":
    "Je hebt deze routine gepland op {days} (geen specifieke tijden).",
  "routine_form.planned_days_with_time": "Je hebt deze routine gepland op {days}.",
  "routine_form.saving": "Opslaan...",

  // Goal Form
  "goal_form.icon": "Icoon",
  "goal_form.tap_to_change_icon": "Tik om icoon te wijzigen",
  "goal_form.click_to_change_icon": "Klik om icoon te wijzigen",
  "goal_form.title": "Titel",
  "goal_form.title_required": "Titel is verplicht",
  "goal_form.title_placeholder": "Titel van je {mode} doel",
  "goal_form.new": "nieuwe",
  "goal_form.updated": "bijgewerkte",
  "goal_form.description": "Beschrijving",
  "goal_form.description_placeholder": "Geef details over dit doel.",
  "goal_form.target_date": "Streef Datum",
  "goal_form.target_date_placeholder": "Selecteer een streef datum",
  "goal_form.target_date_description": "Wanneer wil je dit doel voltooien?",
  "goal_form.target_date_future": "Streef datum moet in de toekomst liggen",
  "goal_form.save_failed": "Kan doel niet opslaan. Probeer het opnieuw.",
  "goal_form.saving": "Opslaan...",

  // Health Area Form
  "health_area_form.select_health_area": "Selecteer een gezondheidsthema",
  "health_area_form.health_area": "Gezondheidsthema",
  "health_area_form.title_required": "Titel is verplicht",
  "health_area_form.save_failed": "Kan gezondheidsthema niet opslaan. Probeer het opnieuw.",
  "health_area_form.goals": "Doelen",
  "health_area_form.goal_count": "Je doel bestaat uit {count} {plural}.",
  "health_area_form.routines": "Routines",
  "health_area_form.routine_count": "Je doel bestaat uit {count} {plural}.",
  "health_area_form.saving": "Opslaan...",

  // Suggestion Cards
  "routine_suggestion.accept": "Accepteren",
  "routine_suggestion.reject": "Afwijzen",
  "goal_suggestion.accept": "Accepteren",
  "goal_suggestion.reject": "Afwijzen",

  // Health Area Card
  "health_area_card.add_health_area": "Gezondheidsthema Toevoegen",
  "health_area_card.added_message": "Gezondheidsthema is toegevoegd aan je account",
  "health_area_card.goals": "doelen",
  "health_area_card.goal": "doel",
  "health_area_card.routines": "routines",
  "health_area_card.routine": "routine",

  // Health Area
  "health_area.create_goal_description":
    "Maak een {healthArea} doel aan om je succes te meten en gemotiveerd te blijven.",
  "health_area.create_routine_description":
    "Bouw consistente {healthArea} gewoonten op met een dagelijkse routine die vooruitgang stimuleert.",

  // Health Areas Page
  "health_areas_page.explore_more": "Ontdek meer gezondheidsthema's",
  "health_areas_page.explore_more_routines": "Ontdek meer routines",
  "health_areas_page.explore_more_goals": "Ontdek meer doelen",

  // Privacy Policy
  "privacy_policy.title": "Privacybeleid",
  "privacy_policy.last_updated": "Laatst bijgewerkt",

  // Terms of Service
  "terms_of_service.title": "Servicevoorwaarden",
  "terms_of_service.last_updated": "Laatst bijgewerkt",

  // Settings Page
  "settings.title": "Instellingen",
  "settings.pro_member": "Pro Lid",
  "settings.free_member": "Gratis Lid",
  "settings.welcome_to": "Welkom bij",
  "settings.sign_in_description": "Meld je aan voor toegang tot je gepersonaliseerde ervaring",
  "settings.login": "Inloggen",
  "settings.sign_up": "Registreren",
  "settings.register": "Registreren",
  "settings.account": "Account",
  "settings.profile_settings": "Profiel Instellingen",
  "settings.account_settings": "Account Instellingen",
  "settings.achieve_more": "Bereik Meer",
  "settings.upgrade_to_pro": "Upgrade naar Pro",
  "settings.preferences": "Voorkeuren",
  "settings.notification_settings": "Notificatie Instellingen",
  "settings.calendar_settings": "Kalender Instellingen",
  "settings.theme": "Thema",
  "settings.support": "Ondersteuning",
  "settings.contact": "Contact",
  "settings.join_whatsapp_community": "WhatsApp Community",
  "settings.follow_social_media": "Volg op Social Media",
  "settings.rate_us": "Beoordeel Ons",
  "settings.share_with_friends": "Deel met Vrienden",
  "settings.share_text": "Bekijk {appName} - Volg en bereik je gezondheidsdoelen!",
  "settings.resources": "Bronnen",
  "settings.blog": "Blog",
  "settings.changelog": "Changelog",
  "settings.more": "Meer",
  "settings.logout": "Uitloggen",
  "settings.delete_account.title": "Account Verwijderen",
  "settings.delete_account.error_title": "Fout",
  "settings.delete_account.error_description":
    "Het verwijderen van je account is mislukt. Probeer het opnieuw.",
  "settings.delete_account.success_title": "Succes",
  "settings.delete_account.success_description": "Je account is verwijderd.",

  // Library Page
  "library.description":
    "Ontdek verschillende gezondheidsthema's, elk met voorgedefinieerde doelen en routines om je reis naar betere gezondheid te starten.",
  "library.no_routines_or_goals_available":
    "Er zijn nog geen routines of doelen beschikbaar in deze categorie.",

  // Resource Dropdown
  "resource_dropdown.delete_confirmation": "Dit zal je {resource} {title} permanent verwijderen.",
  "resource_dropdown.actions": "{resource} Acties",

  // Resource Context Menu
  "resource_context_menu.delete_confirmation":
    "Dit zal je {resource} {title} permanent verwijderen.",
  "resource_context_menu.actions": "{resource} Acties",

  // Edit Delete Dropdown
  "edit_delete_dropdown.delete_confirmation": "Dit zal {title} permanent verwijderen.",
  "edit_delete_dropdown.edit": "Bewerken",
  "edit_delete_dropdown.delete": "Verwijderen",

  // Draggable List
  "draggable_list.step_actions": "Stap Acties",

  // Social Drawer
  "social_drawer.title": "Volg ProgressMade.AI",
  "social_drawer.description": "Verbind met ons op social media",
  "social_drawer.join_whatsapp_community": "Word lid van WhatsApp Community",
  "social_drawer.linkedin": "LinkedIn",
  "social_drawer.x": "X",
  "social_drawer.instagram": "Instagram",
  "social_drawer.tiktok": "TikTok",

  // Routines by Health Area
  "routines_by_health_area.other_routines": "Andere Routines",

  // Health Areas
  "health_areas.nutrition.title": "Voeding",
  "health_areas.nutrition.description":
    "Ontwikkel gezonde eetgewoonten en optimaliseer je voeding voor algeheel welzijn.",
  "health_areas.energy.title": "Energie",
  "health_areas.energy.description": "Verhoog en behoud je energieniveau gedurende de dag.",
  "health_areas.fitness.title": "Fitness",
  "health_areas.fitness.description":
    "Verbeter kracht, uithoudingsvermogen en algehele fysieke conditie door regelmatige oefening.",
  "health_areas.heart.title": "Hart",
  "health_areas.heart.description":
    "Ondersteun cardiovasculaire gezondheid door gerichte gewoonten en activiteiten.",
  "health_areas.hydration.title": "Hydratatie",
  "health_areas.hydration.description":
    "Zorg voor voldoende waterinname gedurende de dag voor optimale lichaamsfunctie.",
  "health_areas.mental.title": "Mentaal",
  "health_areas.mental.description":
    "Ondersteun cognitieve gezondheid en mentaal welzijn door toegewijde praktijken.",
  "health_areas.mood.title": "Stemming",
  "health_areas.mood.description":
    "Verbeter emotionele balans, veerkracht en mindfulness voor een betere stemming en kijk op het leven.",
  "health_areas.movement.title": "Beweging",
  "health_areas.movement.description":
    "Integreer regelmatige beweging in je dagelijkse routine voor betere gezondheid.",
  "health_areas.sleep.title": "Slaap",
  "health_areas.sleep.description":
    "Verbeter slaapkwaliteit en stel consistente slaaproutines vast voor betere gezondheid.",
  "health_areas.stress.title": "Stress",
  "health_areas.stress.description":
    "Ontwikkel effectieve strategieën om met stress om te gaan en een kalme mindset te behouden.",
  "health_areas.weight.title": "Gewicht",
  "health_areas.weight.description":
    "Bereik en behoud een gezond gewicht door duurzame levensstijlveranderingen.",

  // Day Time Selector
  "day_time_selector.monday": "Maandag",
  "day_time_selector.tuesday": "Dinsdag",
  "day_time_selector.wednesday": "Woensdag",
  "day_time_selector.thursday": "Donderdag",
  "day_time_selector.friday": "Vrijdag",
  "day_time_selector.saturday": "Zaterdag",
  "day_time_selector.sunday": "Zondag",
  "day_time_selector.monday_short": "M",
  "day_time_selector.tuesday_short": "D",
  "day_time_selector.wednesday_short": "W",
  "day_time_selector.thursday_short": "D",
  "day_time_selector.friday_short": "V",
  "day_time_selector.saturday_short": "Z",
  "day_time_selector.sunday_short": "Z",
  "day_time_selector.every_day": "Elke dag",
  "day_time_selector.select_time": "Selecteer tijd",

  // Progress Notifications
  "progress_notifications.daily_goal_achieved": "Dagelijks Doel Behaald",
  "progress_notifications.daily_goal_achieved_description":
    "Je hebt vandaag je 10.000 stappen voltooid!",
  "progress_notifications.water_reminder": "Water Herinnering",
  "progress_notifications.water_reminder_description": "Tijd om je 8e glas water te drinken",
  "progress_notifications.workout_completed": "Training Voltooid",
  "progress_notifications.workout_completed_description":
    "Je hebt je 30 minuten cardio sessie afgerond",
  "progress_notifications.new_achievement": "Nieuwe Prestatie",
  "progress_notifications.new_achievement_description": "Je hebt een 5-daagse oefenreeks bereikt!",
  "progress_notifications.nutrition_goal": "Voedingsdoel",
  "progress_notifications.nutrition_goal_description":
    "Je hebt je fruitinname doel voor vandaag behaald",
  "progress_notifications.todays_routines": "Routines van Vandaag",
  "progress_notifications.todays_routines_description": "Je hebt 3 routines gepland voor vandaag",
  "progress_notifications.meditation_reminder": "Meditatie Herinnering",
  "progress_notifications.meditation_reminder_description":
    "Tijd voor je middag mindfulness sessie",
  "progress_notifications.weekly_progress": "Wekelijkse Voortgang",
  "progress_notifications.weekly_progress_description":
    "Je bent 85% op weg naar je wekelijkse fitnessdoel",
  "progress_notifications.consistency_reward": "Consistentie Beloning",
  "progress_notifications.consistency_reward_description":
    "Je bent al 10 dagen op rij consistent geweest",
  "progress_notifications.rest_day": "Rustdag",
  "progress_notifications.rest_day_description": "Morgen is een geplande hersteldag",
  "progress_notifications.time_15m_ago": "15m geleden",
  "progress_notifications.time_10m_ago": "10m geleden",
  "progress_notifications.time_5m_ago": "5m geleden",
  "progress_notifications.time_2m_ago": "2m geleden",
  "progress_notifications.time_just_now": "Zojuist",
  "progress_notifications.time_4h_ago": "4u geleden",
  "progress_notifications.time_3m_ago": "3m geleden",
  "progress_notifications.time_1h_ago": "1u geleden",
  "progress_notifications.time_2h_ago": "2u geleden",
  "progress_notifications.time_30m_ago": "30m geleden",

  // Share Progress
  "share_progress.share_title": "Mijn Wekelijkse Voortgang",
  "share_progress.share_text":
    "Ik heb {percentage}% van mijn routines deze week voltooid! 💪\nPlan ook je gezondheid: https://progressmade.ai",
  "share_progress.no_active_routines":
    "Geen actieve routines om weer te geven. Maak wat routines aan om je voortgang bij te houden!",
  "share_progress.powered_by": "Mogelijk gemaakt door {appName}.ai",
  "share_progress.share_button": "Delen",

  // Android Review Dialog
  "android_review_dialog.title": "Geniet je van ProgressMade?",
  "android_review_dialog.description":
    "Als je de app geweldig vindt, zou je ons dan willen beoordelen op Google Play? Het helpt ons enorm en duurt minder dan een minuut.",
  "android_review_dialog.rate_button": "Beoordeel op Google Play",
  "android_review_dialog.later_button": "Misschien Later",
  "android_review_dialog.no_thanks_button": "Nee Bedankt",
};

export default messages;
